import { render, staticRenderFns } from "./Contactlist.vue?vue&type=template&id=1bb22916&"
import script from "./Contactlist.vue?vue&type=script&lang=js&"
export * from "./Contactlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports